import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyService } from './MyService';
import { LoggerModule } from 'ngx-logger';

import { environment } from '../..//environments/environment';
import { StorageService } from './storage-service';

@NgModule({
  declarations: [],
  imports: [
    LoggerModule.forRoot(environment.logging),
  ],
  providers:[],
  exports: []
})
export class ShareModule { }
